import type { AxiosError } from 'axios';
import type { Result } from '~/types';
import axios from 'axios';

export async function post<T = unknown>(
  url: string,
  body: any,
): Promise<Result<T>> {
  try {
    const response = await axios.post(url, body, {
      getAccessToken: true,
      timeout: 120000,
    } as any);
    return {
      ok: true,
      value: response.data as T,
    };
  } catch (e) {
    const error = e as AxiosError;
    return {
      ok: false,
      error,
    };
  }
}
